import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

export const adminHeaders = () => ({
  Authorization: `Bearer ${sessionStorage.getItem("lr_admin_token") || ""}`,
});

export function formatApiError(detail, fallback = "Algo deu errado. Tente novamente.") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg.replace(/^Value error,\s*/i, "") : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
